import { render, staticRenderFns } from "./QTrainingSubmenu.vue?vue&type=template&id=0ed824f8&"
import script from "./QTrainingSubmenu.vue?vue&type=script&lang=js&"
export * from "./QTrainingSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports